import axios from "axios"
import getBaseUrl from "./getBaseUrl";

const headers = {
    "Content-Type": "application/json",
    "accept": "*/*"
};

export const client = axios.create({
    baseURL: getBaseUrl() + "/api",
    headers
})

client.interceptors.response.use(
    function(response) {
        return response
    },
    function(error) {
        if(error?.response?.status === 401) {
            console.log("unauth")
        } 

        return Promise.reject(error)
    }
)